import { useEffect, useState } from 'react';

// watches for scroll on the body
export function useBodyScroll(): {
  amount: number; // how far they have scrolled
  direction: 'up' | 'down'; // which direction they are scrolling
} {
  const [amount, setAmount] = useState(0);
  const [direction, setDirection] = useState<'up' | 'down'>('down');
  useEffect(() => {
    let lastScrollTop = 0;

    const handleScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      setAmount(scrollTop);
      if (scrollTop > lastScrollTop) {
        setDirection('down');
      } else {
        setDirection('up');
      }
      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return {
    amount,
    direction,
  };
}
